<template>
  <div class="global-body-style">
    <el-tabs v-model="activeName" class="base-normal-tab-layout">
      <el-tab-pane label="待分配" name="beDis" v-if="hasDistribute" lazy>
        <be-distributed v-if="activeName === 'beDis'" ref="tobeDistributedRef"></be-distributed>
      </el-tab-pane>
      <el-tab-pane label="归属记录" name="result" v-if="hasRecord" lazy>
        <YorkerRecorde v-if="activeName === 'result'" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import BeDistributed from './beDistributed';
import YorkerRecorde from './recorde';
export default{
  name: 'NewYorker',
  components: {
    BeDistributed,
    YorkerRecorde
  },
  data () {
    return {
      activeName: 'beDis',
      hasDistribute: false,
      hasRecord: false
    }
  },
  async created() {
    this.hasDistribute = await this.$store.dispatch('user/hasPermission', 'customer.new.list');
    this.hasRecord = await this.$store.dispatch('user/hasPermission', 'customer.new.distribute-result');
    this.activeName = this.hasDistribute ? 'beDis' : 'result';
  },
}
</script>
<style lang="less">
@import url('~@/assets/style/base/tab.less');
</style>